import { AxiosPromise, AxiosResponse } from 'axios';
import { RootState } from 'data/root.reducers';
import { ServerResponse } from 'data/types';
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';

export const API_PATH_CERT_STATUS = '/certstatus';

export type CertStatusGridData = {
  id: string;
  commonName: string;
  validDays: string;
  status:
  | 'UNKNOWN'
  | 'CSRSENT'
  | 'PENDING_APPROVAL'
  | 'APPROVED'
  | 'DOWNLOADED'
  | 'ACTIVATED'
  | 'REVOKED'
  | 'EXPIRED';
  errorMsg: string;
  expireDate: string;
}

export interface CertStatus {
  id: string;
  CERTID?: string;
  AFTYPE: string;
  LITYPE: 'INI1' | 'INI2' | 'INI3';
  COMMONNAME: string;
  ORGANIZATION?: string;
  ORGUNIT?: string;
  COUNTRY?: string;
  STATE?: string;
  LOCALITY?: string;
  EMAIL?: string;
  EXPIREDATE?: string;
  ERRMSG?: string;
  SAN?: string;
  VALIDDAYS: string;
  KEYALGORITHM: 'RSA_2048' | 'RSA_4096' |'RSA_8192' | 'ECDSA_256' | 'ECDSA_384' | 'ECDSA_521';
  DIGEST: 'SHA1' | 'SHA256' | 'SHA512';
  SERIALNUMBER: string;
  STATUS:
  | 'UNKNOWN'
  | 'CSRSENT'
  | 'PENDING_APPROVAL'
  | 'APPROVED'
  | 'DOWNLOADED'
  | 'ACTIVATED'
  | 'REVOKED'
  | 'EXPIRED';
  ACTION: 'NONE' | 'ACTIVATE' | 'REVOKE' | 'RENEW' | 'KEYUPDATE';
}

export interface CertStatusState {
  entities: CertStatus[];
  selected: CertStatus[];
  single: CertStatus | null;
  createdId: string | null;
}

export const GET_CERT_STATUS_LIST = 'GET_CERT_STATUS_LIST';
export const GET_CERT_STATUS_LIST_PENDING = 'GET_CERT_STATUS_LIST_PENDING';
export const GET_CERT_STATUS_LIST_FULFILLED =
  'GET_CERT_STATUS_LIST_FULFILLED';

export const CREATE_CERT_STATUS = 'CREATE_CERT_STATUS';
export const CREATE_CERT_STATUS_PENDING = 'CREATE_CERT_STATUS_PENDING';
export const CREATE_CERT_STATUS_FULFILLED = 'CREATE_CERT_STATUS_FULFILLED';

export const ACTIVATE_CERT_STATUS = 'ACTIVATE_CERT_STATUS';
export const ACTIVATE_CERT_STATUS_PENDING = 'ACTIVATE_CERT_STATUS_PENDING';
export const ACTIVATE_CERT_STATUS_FULFILLED = 'ACTIVATE_CERT_STATUS_FULFILLED';

export const DELETE_CERT_STATUS = 'DELETE_CERT_STATUS';
export const DELETE_CERT_STATUS_PENDING = 'DELETE_CERT_STATUS_PENDING';
export const DELETE_CERT_STATUS_FULFILLED = 'DELETE_CERT_STATUS_FULFILLED';

export interface GetCertStatusListAction extends AnyAction {
  type: typeof GET_CERT_STATUS_LIST;
  payload: AxiosPromise<ServerResponse<CertStatus>>;
}

export interface GetCertStatusListPendingAction extends AnyAction {
  type: typeof GET_CERT_STATUS_LIST_PENDING;
  payload: null;
}

export interface GetCertStatusListFulfilledAction extends AnyAction {
  type: typeof GET_CERT_STATUS_LIST_FULFILLED;
  payload: AxiosResponse<ServerResponse<CertStatus>>;
}

export interface CreateCertStatusThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface CreateCertStatusAction extends AnyAction {
  type: typeof CREATE_CERT_STATUS;
  payload: AxiosPromise<ServerResponse<CertStatus>>;
}

export interface CreateCertStatusPendingAction extends AnyAction {
  type: typeof CREATE_CERT_STATUS_PENDING;
  payload: AxiosResponse<ServerResponse<CertStatus>>;
}

export interface CreateCertStatusFulfilledAction extends AnyAction {
  type: typeof CREATE_CERT_STATUS_FULFILLED;
  payload: AxiosResponse<ServerResponse<CertStatus>>;
}

export interface ActivateCertStatusThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export interface DeleteCertStatusThunkAction extends ThunkAction<void, RootState, void, AnyAction> {}

export type CertStatusActionTypes =
  | GetCertStatusListAction
  | GetCertStatusListPendingAction
  | GetCertStatusListFulfilledAction
  | CreateCertStatusAction
  | CreateCertStatusPendingAction
  | CreateCertStatusFulfilledAction;
